import { endOfDay, format } from 'date-fns';

const EODBoundary = [null, endOfDay(Date.now())] as [null, Date];

function formatDate(date?: string | Date, dateFormat = 'd MMM yyyy') {
  return date ? format(new Date(date), dateFormat) : '';
}

export { EODBoundary, formatDate };
